/**
 * GENERADO por `scripts/generar-qr-login.js`: no se edita a mano (#1686, R32).
 * Matriz del QR de la URL de inicio de sesión de la app, nivel de corrección M. Sin token, correo ni
 * identificador de la cuenta: es la misma imagen para todo el mundo.
 */
export const URL_QR_LOGIN = "https://app.smardx.com/authentication";
export const LADO_QR_LOGIN = 29;
// Una fila por string, "1" = módulo oscuro.
export const FILAS_QR_LOGIN = [
  "11111110100001001111001111111",
  "10000010110001001010001000001",
  "10111010010001010011101011101",
  "10111010110100000101001011101",
  "10111010001001111101001011101",
  "10000010010100100001101000001",
  "11111110101010101010101111111",
  "00000000100001100111000000000",
  "10110111000111111110001001011",
  "10001001111000001001101110001",
  "11011010011000100110000110110",
  "00011000100011100010010110001",
  "00101011010010011100000001100",
  "01010100111111011111001100111",
  "10111111101110100011010000111",
  "10001001001001010011100010010",
  "01100110011110000011110011010",
  "01100101100101010100000101110",
  "10000011001100011010010010100",
  "00110101111010010100110100100",
  "01111010111101001110111111100",
  "00000000101111101011100011111",
  "11111110111011001111101011010",
  "10000010110110001010100011011",
  "10111010000010100100111110100",
  "10111010100000111000110011001",
  "10111010111000001110010100101",
  "10000010000010011010110111010",
  "11111110100100101011101100010"
];
